import React from 'react';

import { ProductButtonProps } from '../..';
import { BatchTicketButton } from '../../components/BatchTicketButton';

export const FixedIncomeButton: React.FC<ProductButtonProps<'fixedIncome'>> = (props) => {
  return (
    <BatchTicketButton {...props} isDisabled={props.isDisabled} idSelector="productIdNormalized" />
  );
};
